import { site, extensions, errors } from '@yola/ws-sdk';
import getAvailableExtensions from '../registry/get-available-extensions';

const registerExtensions = () => (next) => (action) => {
  if (action.type === site.actionTypes.CONNECT_SITE) {
    const extensionPromises = [];

    getAvailableExtensions().forEach((extension) => {
      try {
        extensions.operations.registerExtension(extension);

        // Call init() if it exists
        if (extension.init && typeof extension.init === 'function') {
          const initPromise = Promise.resolve(extension.init());
          extensionPromises.push(initPromise);
        }
      } catch (error) {
        console.error(`Error registering extension with slug: ${extension.slug}`, error);
        errors.operations.catchError(error);
      }
    });

    Promise.all(extensionPromises)
      .then(() => {
        next(action);
      })
      .catch((error) => {
        errors.operations.catchError(error);
      });
  } else {
    next(action);
  }
};

export default registerExtensions;
